const useStyles = theme => ({
    desktopContainer: {
        flexGrow: 1,
        display: 'flex',
        paddingLeft: 15,
    },
    desktopNextUpText: {
        marginTop: 15,
        marginBottom: 8,
    },
    desktopListContainer: {
        paddingRight: 20,
        zIndex: 1,
    },
    desktopList: {
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          width: 8
        }
    },
    desktopListFooterItem: {
        padding: 0,
        height: 80
    },
    desktopGradientBox: {
        zIndex: 2,
        marginRight: 8,
        marginTop: -80,
        height: 90,
        pointerEvents:'none'
    },
    desktopListItemContainer: {
        height: 110,
        cursor: 'pointer'
    },
    desktopListItemText: {
        marginTop: 15,
    },
    desktopListItemDurationContainer: {
        marginTop: 15
    },
    desktopListItemDurationText: {
        marginBottom: 8,
        marginTop: 3,
    },
    desktopListItemDivider: {
        height: 2,
    },
    desktopListItemIconButton: {
        height: 50,
        width: 50
    },
    mobileContainer: {
        flexGrow: 1,
        display: 'flex'
    },
    mobileNextUpText: {
        marginTop: 15,
        marginBottom: 8,
        paddingLeft: 10
    },
    mobileSlider: {
        marginBottom: 35
    },
    mobileListItemContainer: {
        height: 110,
        paddingBottom: 10,
    },
    mobileListItemTextsContainer: {
        paddingLeft: 10,
    },
    mobileListItemText: {
        marginTop: 15,
    },
    mobileListItemDurationContainer: {
        marginTop: 10
    },
    mobileListItemDurationText: {
        marginBottom: 8,
        marginTop: 3,
    },
    mobileListItemIconButton: {
        marginRight: 15,
        height: 50,
        width: 50
    },
    twoTextLinesBox: {
        display: "-webkit-box",
        boxOrient: "vertical",
        lineClamp: 2,
        wordBreak: "break-word",
        overflow: "hidden",
      }
});
export default useStyles
